import { Trip } from '@/types';

// Klassifiziere Reisen basierend auf dem Enddatum
export const isTripCurrent = (trip: Trip): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day for fair comparison
  const endDate = new Date(trip.endDate);
  endDate.setHours(23, 59, 59, 999); // Set to end of day
  // Reise ist aktuell wenn das Enddatum heute oder in der Zukunft liegt
  return endDate >= today;
};

export const isTripPast = (trip: Trip): boolean => {
  return !isTripCurrent(trip);
};

// Sortiere Reisen nach Startdatum (neueste zuerst für aktuelle, älteste zuerst für vergangene)
export const sortTripsByDate = (trips: Trip[], isCurrentSection: boolean = true): Trip[] => {
  return [...trips].sort((a, b) => {
    const dateA = new Date(a.startDate);
    const dateB = new Date(b.startDate);
    
    if (isCurrentSection) {
      // Für aktuelle Reisen: nächste Reisen zuerst
      return dateA.getTime() - dateB.getTime();
    } else {
      // Für vergangene Reisen: neueste zuerst
      return dateB.getTime() - dateA.getTime();
    }
  });
};

// Gruppiere Reisen in aktuelle und vergangene
export const groupTripsByDate = (trips: Trip[]) => {
  const currentTrips = trips.filter(isTripCurrent);
  const pastTrips = trips.filter(isTripPast);
  
  return {
    current: sortTripsByDate(currentTrips, true),
    past: sortTripsByDate(pastTrips, false)
  };
};